import {useEffect, useState} from 'react';
import './gallery.css'
const EMAILSERVERADDRES = "https://www.newphasereno.ca/api"
//   var images = require.context("../../../public/projects", true);
//   images.keys().forEach(element => {
//   if(imageCollections[element.split('/')[1]] === undefined){
//     imageCollections[element.split('/')[1]]=[
//       process.env.PUBLIC_URL+"/projects"+element.split('.')[1]+"."+element.split('.')[2]
//     ]
    
//   }else{
//     imageCollections[element.split('/')[1]] = [
//       ...imageCollections[element.split('/')[1]],
//       process.env.PUBLIC_URL+"/projects"+element.split('.')[1]+"."+element.split('.')[2]
//     ]
//   }
// });
  //create image gallery
function rotateCollection(dir,selection,len){
  var current = selection+dir;
  if(current < len && current >= 0) return selection+dir;
  if(current < 0) return len - 1;
  return 0;
}
function SlidShow(para){
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isMultiTouch, setisMultiTouch] = useState(false);
  const [imgId,setImgId] = useState(0);
  const [imgLoaded,setImgLoaded] = useState(false);
 
  const unselect = para.unselect;
  const minSwipeDistance = 70; 
  const notify = para["notify"];
  var imageList = para['imageList'];
  var nextId = imgId + 1;
  var prevId = imgId - 1;
  console.info(notify);
  if(imgId === 0){
    prevId = imageList.length - 1;
  }
  if(imgId === imageList.length - 1){
    nextId = 0;
  }
  var currentImg = 
    <img 
    alt="demo"
    id = "currentImg" 
    onLoad={() => {
      setImgLoaded(true);
    }}
    src={imageList[imgId]}/>
  
  var prevImg = 
    <img
      alt="demo"
      id = "prevImg" 
    src={imageList[prevId]}/>
  
    var nextImg = 
    <img
      alt="demo"
      id = "nextImg" 
    src={imageList[nextId]}/>


  const onTouchStart = (e) => {
    if(e.targetTouches.length > 1)setisMultiTouch(true);
    setTouchStart(e.targetTouches[0].clientX);
  }
  const onTouchMove = (e) => {
    if(window.visualViewport.scale > 1)return;
    if(isMultiTouch){
      setisMultiTouch(false);
      setTouchEnd(null);
      return;
    }
    document.getElementById("currentImg").style.left = String(1.5*(e.targetTouches[0].clientX - touchStart)+document.getElementById("currentImg").offsetWidth/2)+"px";
    document.getElementById("nextImg").style.left = String(1.5*(e.targetTouches[0].clientX - touchStart)+document.getElementById("nextImg").offsetWidth/2)+"px";
     document.getElementById("prevImg").style.left = String(1.5*(e.targetTouches[0].clientX - touchStart)+document.getElementById("prevImg").offsetWidth/2)+"px";
    // .style.left();
    setTouchEnd(e.targetTouches[0].clientX);
    
  }
  const onTouchEnd = (e) => {
    
    if(window.visualViewport.scale > 1){
      document.getElementById("next").style.display = "none";
      document.getElementById("prev").style.display = "none";
      document.getElementById("exit").style.display = "none";
      return;
    }
    document.getElementById("next").style.display = null;
    document.getElementById("prev").style.display = null;
    document.getElementById("exit").style.display = null;
    if(isMultiTouch){
      setisMultiTouch(false);
      setTouchEnd(null);
      document.getElementById("currentImg").style.left = null;
      document.getElementById("nextImg").style.left = null;
      document.getElementById("prevImg").style.left = null;
      return;
    }
    if (!touchStart || !touchEnd) {
      setTouchEnd(null);
      document.getElementById("currentImg").style.left = null;
      document.getElementById("nextImg").style.left = null;
      document.getElementById("prevImg").style.left = null;
      return;}
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    setTouchEnd(null);
    
    if (isLeftSwipe)setImgId(rotateCollection(+1,imgId,imageList.length));
    if(isRightSwipe)setImgId(rotateCollection(-1,imgId,imageList.length));
    document.getElementById("currentImg").style.left = null;
    document.getElementById("nextImg").style.left = null;
    document.getElementById("prevImg").style.left = null;
  }
// start an loop that stops on componet destruction
  // useEffect(()=>{
  //   var intId = setInterval(()=>{
  //     if(imgId < imageList.length-1){
  //       setImgId(imgId + 1);
  //     }
  //     else{
  //       setImgId(0)
  //     };
  //   },interval)
  //   return()=>{
  //     clearInterval(intId);
    // }
  // })
  return(
    <div id = "showBox"
      onTouchStart={onTouchStart} 
      onTouchMove={onTouchMove} 
      onTouchEnd={onTouchEnd} >
      <button id="exit" onClick={unselect}>X</button>
      {imgLoaded? 
        <div>{prevImg}{currentImg}{nextImg}</div>:
        <div style={{display:"none"}}>{prevImg}{currentImg}{nextImg}</div>}
      <button id="prev" onClick={()=>{setImgId(rotateCollection(-1,imgId,imageList.length));setImgLoaded(false);}}>&#10094;</button>
      <button id="next" onClick={()=>{setImgId(rotateCollection(1,imgId,imageList.length));setImgLoaded(false);}}>&#10095;</button>
      <span id="count">{imgId+1}/{imageList.length}</span>
    </div>
  );
}

function Gallery(){
  
  const [imageCollections,setImageCollections] = useState({});
  const [loading,setLoading] = useState(true);
  const[select,setSelection] = useState(undefined);
  const[notify,setNotifiy] = useState(0);
  useEffect(()=>{
    const temp = []
    async function fetchData(){
      let payload = {
        method:"GET",
          headers:{
            "Access-Control-Allow-Origin": "*",
          }
      }
      const r = await fetch(EMAILSERVERADDRES+"/get_img_dirlist",payload)
      if(r.ok){
        const data = await r.json();
        const projects = Object.keys(data);
        for(var x = 0; x < projects.length; x++){
          for(var i = 0; i < data[projects[x]].length; i++){
            let payload = {
            method:"POST",
            headers:{
              "content-type":"application.json"
            },
            body: JSON.stringify({
              "folder":projects[x],
              "filename":data[projects[x]][i]
            })
            }  
            const res = await fetch(EMAILSERVERADDRES+"/get_img",payload)
            if(res.ok){
              const blob = await res.blob();
                if(temp[projects[x]] === undefined){
                  temp[projects[x]]=[URL.createObjectURL(blob)];
                }else{
                  temp[projects[x]]=[...temp[projects[x]],URL.createObjectURL(blob)];
                }
              
            }
          setNotifiy(prev => prev+1);
          setImageCollections(temp);
          }
        
        }
      setLoading(false);
      }
    }
    
    fetchData()
  },[]);
  if(loading)console.info("imgLoaded");
  const presentations = [];
  function unselect(){
    setSelection(undefined);
  } 
  Object.keys(imageCollections).forEach(dictkey=>{
    presentations.push(
      <div className='slidsBox' key = {dictkey} >
        <img
          src = {imageCollections[dictkey][0]} 
          onClick = {()=>setSelection(dictkey)}
          alt={"error"}
        />
      </div>
    );
    
  })
  
  return(
    <div id = 'GalleryBox'>
      {presentations}
      {select !== undefined && 
        <div>
          <div id="blur" className='lock-scroll'></div>
          <SlidShow 
              imageList={imageCollections[select]}
              unselect = {unselect}
              notify = {notify}
          />
        </div>
      }
      
    </div>

  );
}
export default Gallery;